// ============================================================
// calendarIcons.tsx — Feather line icons for the calendar markers that were
// emoji (🔔 reminder, 🗒 day note, 📅 Outlook / appointment). Emoji render
// inconsistently across platforms, are skipped by some screen readers when
// sat on a bare <span aria-label>, and break the design doc's "inline
// Feather SVG, currentColor" icon rule (§6). Colour inherits via
// currentColor; size via className (default w-3 h-3).
//
// <CalMarker> wraps an icon as an ACCESSIBLE marker (role="img" +
// aria-label + title) for the places where the icon alone carries meaning.
// ============================================================
import React from 'react'

type IconProps = { className?: string }

const Base: React.FC<IconProps & { children: React.ReactNode }> = ({ className, children }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
    strokeLinejoin="round" className={className ?? 'w-3 h-3'} aria-hidden="true" focusable="false">
    {children}
  </svg>
)

export const IcBell: React.FC<IconProps> = (p) => (
  <Base {...p}><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" /></Base>
)
export const IcNote: React.FC<IconProps> = (p) => (
  <Base {...p}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" /></Base>
)
export const IcCalendar: React.FC<IconProps> = (p) => (
  <Base {...p}><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></Base>
)

// Accessible stand-alone marker (the icon IS the information).
export const CalMarker: React.FC<{ label: string; icon: React.ReactNode; className?: string }> = ({ label, icon, className }) => (
  <span role="img" aria-label={label} title={label} className={`inline-flex items-center leading-none ${className ?? ''}`}>
    {icon}
  </span>
)
